export const defaultSections = [
  {
    id: 1,
    title: "વ્યક્તિગત માહિતી",
    fields: [
      { id: 1, label: "નામ", value: "નામ લખો" },
      { id: 2, label: "જન્મ તારીખ", value: "જન્મ તારીખ લખો" },
      { id: 3, label: "રંગ", value: "રંગ લખો" },
      { id: 4, label: "શિક્ષણ", value: "શિક્ષણ લખો" },
      { id: 5, label: "વ્યવસાય", value: "તમારો વ્યવસાય લખો" },
      { id: 6, label: "આવક", value: "આવક લખો" },
      { id: 7, label: "કદ", value: "કદ લખો" }
    ]
  },
  {
    id: 2,
    title: "પરિવારના સભ્ય",
    fields: [
      { id: 8, label: "પિતાજીનુ નામ", value: "પિતાજીનુ નામ લખો" },
      { id: 9, label: "પિતાજીનો વ્યવસાય લખો", value: "પિતાજીનો વ્યવસાય" },
      { id: 10, label: "માતાજીનુ નામ", value: "માતાજીનુ નામ લખો" },
      { id: 11, label: "માતાજીનો વ્યવસાય", value: "માતાજીનો વ્યવસાય લખો" }
    ]
  },
  {
    id: 3,
    title: "સંપર્ક સૂત્ર",
    fields: [
      { id: 12, label: "નામ", value: "નામ લખો" },
      { id: 13, label: "ફોન નંબર", value: "ફોન નંબર લખો" },
      { id: 14, label: "એડ્રેસ", value: "સરનામુ લખો" }
    ]
  }
];




